import React from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from '../ContactPage.module.scss';

function ContactMyRequest(): JSX.Element {
  const { t } = useTranslation(['contactPage', 'translation']);

  return (
    <div className={styles.actionToolbar}>
      <Button type="submit">{t('LABEL_SEND_THE_MESSAGE')}</Button>
    </div>
  );
}

export default ContactMyRequest;
